import { getSystem } from '@commons/config';
import PropTypes from 'prop-types';
import React from 'react';
// eslint-disable-next-line import/no-unresolved
import Parcel from 'single-spa-react/parcel';

const LocationParcel = ({
  isUserLogged,
  searchedLocation,
  currentUser,
  setSearchedLocation,
  setAddressInSearchForm,
  validateNewAddress,
  onSuccess,
  onCancel,
  trackMapLoaded,
  show,
  origin,
}) => {
  const onFinish = async data => {
    validateNewAddress(data);
    await setSearchedLocation(data);
    setAddressInSearchForm(data);
    if (onSuccess) onSuccess(data);
  };
  return (
    <Parcel
      flow="LOCATION_HOME"
      onMapLoaded={trackMapLoaded}
      isUserLogged={isUserLogged}
      currentUser={currentUser}
      onFinish={onFinish}
      onClose={onCancel}
      origin={origin}
      defaultLocation={searchedLocation}
      config={() => getSystem().import('@microsite/web-location')}
      withCta={false}
      show={show}
    />
  );
};

LocationParcel.propTypes = {
  isUserLogged: PropTypes.bool,
  searchedLocation: PropTypes.object,
  currentUser: PropTypes.object,
  setSearchedLocation: PropTypes.func,
  setAddressInSearchForm: PropTypes.func,
  onCancel: PropTypes.func,
  onSuccess: PropTypes.func,
  trackMapLoaded: PropTypes.func,
  show: PropTypes.bool,
  origin: PropTypes.string,
  validateNewAddress: PropTypes.func,
};

export default LocationParcel;
